(function() {

	var Container = include("PIXI.Container"),
		Texture = include("PIXI.Texture"),
		Sprite = include("PIXI.Sprite"),
		Application = include("springroll.Application"),
		UIClue;

	var TargetLetterUI = function()
	{
		if(!UIClue)
			UIClue = include("heist.UIClue");
		
		Container.call(this);
		
		var app = Application.instance;
		this.state = app.manager.getStateById("clue");

		this.background = new Sprite(Texture.fromFrame("stage2_container"));
		this.addChild(this.background);
		this.letter = new Sprite(Texture.fromFrame("stage2_" + app.currentCrimeConfig.letter));
		this.addChild(this.letter);
		
		this.clues = [];
		this.clueTargetPositions = {};

		this.letterVO = "Elmo_" + app.currentCrimeConfig.letter;
		
		this.playVO = this.playVO.bind(this);
		this.onClick = this.onClick.bind(this);
	};

	var p = TargetLetterUI.prototype = Object.create(Container.prototype);
	var s = Container.prototype;
	
	p.enable = function()
	{
		this.interactive = true;
		this.buttonMode = true;
		
		this.on("click", this.onClick);
		this.on("tap", this.onClick);
	};
	
	p.getNextCluePosition = function(clueID)
	{
		if(!this.clueTargetPositions[clueID])
		{
			var clueUIPositions = Application.instance.config.game.clues.clueUIPositions;
			var numActive = 0;
			for(var id in this.clueTargetPositions)
				numActive++;
			this.clueTargetPositions[clueID] = clueUIPositions[numActive];
		}
		return this.clueTargetPositions[clueID];
	};

	p.setClueFound = function(state, newClue)
	{
		var clueUIPositions = Application.instance.config.game.clues.clueUIPositions;
		var position = clueUIPositions[this.clues.length];
		var clue = new UIClue(state, newClue);
		clue.position.x = position.x;
		clue.position.y = position.y;
		clue.enable();
		this.addChild(clue);
		this.clues.push(clue);
		return clue;
	};

	p.onClick = function()
	{
		this.state.uiClicks++;
		//play on a slight delay to allow child clicks to take precedence
		setTimeout(this.playVO, 0);
	};
	
	p.playVO = function()
	{
		this.state.playVO(this.letterVO);
	};

	p.destroy = function()
	{
		s.destroy.call(this);
		this.background.destroy();
		this.letter.destroy();
		for(var i = 0; i < this.clues.length; ++i)
			this.clues[i].destroy();
		this.background = this.letter = this.clues = this.state = null;
	};

	namespace('heist').TargetLetterUI = TargetLetterUI;
}());